// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const rateComparisonWrapper = "RateComparison__rateComparisonWrapper__8rup2";
export const rateComparison = "RateComparison__rateComparison__ywGjD";
export const green = "RateComparison__green__nzYoO";
export const median = "RateComparison__median__3heUp";
export const userRate = "RateComparison__userRate__65Q+1";
export const userRateTooltip = "RateComparison__userRateTooltip__Py2VL";
export const totalMin = "RateComparison__totalMin__vLXZs";
export const totalMax = "RateComparison__totalMax__Y82bj";